/**
 * Per-browser preferences for the QR label safety prompts.
 *
 * localStorage rather than the server, matching FeatureTogglesTab's presets:
 * there is no backend table for UI preferences today. The practical effect
 * is that dismissing the prompt on a laptop does not dismiss it on a shared
 * office machine -- which is the safer default for a prompt about physical
 * label tampering, so it is not worth adding a table just to sync it.
 *
 * Both default to ON. A user who has never touched settings gets the
 * warning; only an explicit opt-out turns it off.
 */
const KEY = "beekeeper.qr_prefs";

const DEFAULTS = {
  // Show the placement/tamper warning before printing labels.
  showPrintWarning: true,
};

export function getQrPreferences() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    // Corrupt value (hand-edited, or written by an older build) must not
    // silently disable a safety prompt -- fall back to showing it.
    return { ...DEFAULTS };
  }
}

export function setQrPreference(name, value) {
  const next = { ...getQrPreferences(), [name]: value };
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

/** Deep link used by the prompt itself, so a user can turn it off from the
 * dialog instead of hunting through Settings. Must stay in sync with the
 * tab key registered in pages/settings/SettingsPage.jsx. */
export const QR_SETTINGS_PATH = "/settings/qr";
